"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ImgSize = _interopRequireDefault(require("../constants/ImgSize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getUrlImg = (url, option) => {
  let imgURL = url;
  if (option?.size) imgURL += `?width=${_ImgSize.default[option.size]}`;
  if (option?.size && option?.isSquare) imgURL += `&height=${_ImgSize.default[option.size]}`;
  return imgURL;
};
var _default = exports.default = getUrlImg;